import React, { useState } from 'react';
import Pagination from 'react-bootstrap/Pagination';
import ToggleButton from 'react-bootstrap/ToggleButton';
import Spinner from 'react-bootstrap/Spinner';
import ProgressBar from "react-bootstrap/esm/ProgressBar";
import ToggleButtonGroup from 'react-bootstrap/ToggleButtonGroup'
import { useEffect } from 'react';
import { getSuggestions } from './utils';

import moment from 'moment';
function Suggestion(props) {
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(true);
  const [suggestedDates, setSuggestedDates] = useState([]);
  const [suggestedDate, setSuggestedDate] = useState("");
 const getDayOfWeek = function(time){
		const suggestedTime = moment(time,"DD-MMM-YYYY HH:mm")
return  suggestedTime.format("dddd")
	}

  const getFormattedDate = function(time){
		const suggestedTime = moment(time,"DD-MMM-YYYY HH:mm")
return  suggestedTime.format("DD-MMM")
	}

  const getFormattedTime = function(time){
		const suggestedTime = moment(time,"DD-MMM-YYYY HH:mm")
return  suggestedTime.format("HH:mm")
	}
  const handlePageUpdate = function(event){
    const a = event.target;
    const pageNumber = a.dataset.value ? parseInt(a.dataset.value, 10) : parseInt(a.parentNode.dataset.value, 10);
		setPage(pageNumber)
	}

  useEffect(() => {
    setLoading(true)
    getSuggestions(props.currentItem.id, page-1, undefined, 10)
      .then(
        (result) => {
          setSuggestedDates(result && Array.isArray(result.suggestions) ? result.suggestions : [])
          setLoading(false)
        })
      .catch((err) => {
        console.error("Failed to load suggestions", err)
        setSuggestedDates([])
        setLoading(false)
      })
  }
// eslint-disable-next-line react-hooks/exhaustive-deps
,[page])

  return (
    <div className="mb-3">
      <div className="text-muted small mb-1"><i className="bi bi-lightbulb me-1"></i>Suggested times</div>
      {!loading && suggestedDates.length === 0 &&
        <div className="text-muted small mb-2">No suggestions on this page.</div>
      }
      {!loading && <>
        <ToggleButtonGroup name="suggestion" className="d-flex flex-wrap w-100 gap-2 mb-2">
          {suggestedDates && Array.isArray(suggestedDates) && suggestedDates.map((radio, idx) => (
            <ToggleButton
              key={idx}
              id={`radio-${idx}`}
              type="radio"
              variant="outline-primary"
              name="radio"
              className="text-start py-2 rounded flex-grow-0"
              style={{ width: 'calc(50% - 0.25rem)' }}
              value={radio.time}
              checked={suggestedDate === radio.time}
              onChange={(e) => { setSuggestedDate(e.currentTarget.value); props.selectRadioSuggestion(e.currentTarget.value); }}
            >
              <div className="d-flex justify-content-between align-items-center">
                <span>{getDayOfWeek(radio.time)}, {getFormattedDate(radio.time)}</span>
                <span className="fw-bold">{getFormattedTime(radio.time)}</span>
              </div>
              <ProgressBar now={radio.effortPercentage} variant={props.getProgressBarType(radio.effortPercentage)} style={{ height: '4px' }} className="mt-1" />
            </ToggleButton>
          ))}
        </ToggleButtonGroup>
        <Pagination size="sm" className="mb-0">
          {Array.from({ length: 10 }, (_, i) => i + 1).map((pageNumber) => (
            <Pagination.Item key={pageNumber} data-value={pageNumber} onClick={handlePageUpdate} active={page===pageNumber}>{pageNumber}</Pagination.Item>
          ))}
        </Pagination>
      </>}

      {loading && <span className="text-muted small">Loading <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /></span>}
    </div>
  );
}
export default Suggestion